module.exports = __webpack_public_path__ + "static/img/module_title.eda2826a.png";